var p = Object.defineProperty;
var d = (r, t, e) => t in r ? p(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e;
var c = (r, t, e) => d(r, typeof t != "symbol" ? t + "" : t, e);
import { LOCAL_STORAGE_SERVICE as f, LOGGER as O } from "@packages/common";
import { Injectable as v, Inject as a } from "@webmotors/ioc";
import "./main18.js";
import "./main21.js";
import { GEOLOCATION_COOKIE_SERVICE as E } from "./main22.js";
import "./main24.js";
import "./main27.js";
import "./main30.js";
import { LEAD_FORM_DATA_SERVICE as _ } from "./main31.js";
import { ADOBE_SERVICE as n } from "./main4.js";
import { UserTransformer as D } from "./main72.js";
var h = Object.getOwnPropertyDescriptor, u = (r, t, e, o) => {
  for (var i = o > 1 ? void 0 : o ? h(t, e) : t, m = r.length - 1, g; m >= 0; m--)
    (g = r[m]) && (i = g(i) || i);
  return i;
}, s = (r, t) => (e, o) => t(e, o, r);
let l = class {
  /**
   * Initializes a new instance of the `AdobeService` class.
   * @param storage - The local storage service for managing local storage operations.
   * @param leadFormData - The lead form data service for handling cookies.
   * @param loggerFactory - The logger factory for creating a logger instance.
   */
  constructor(r, t, e, o) {
    c(this, "logger");
    this.storage = r, this.leadFormData = t, this.geolocation = e, this.loggerFactory = o, this.logger = this.loggerFactory.create(n);
  }
  /**
   * Creates a data layer object by merging default values with input parameters.
   *
   * @param params - The custom data layer parameters.
   * @param user - The current user object, or `null` if not logged in.
   * @returns The merged data layer object.
   */
  createDataLayerObject({
    params: r,
    eventType: t,
    user: e
  }) {
    const o = this.getDefaultDataLayer(e), i = {
      ...o,
      ...r,
      site: {
        ...o.site,
        ...r.site
      },
      page: {
        ...o.page,
        ...r.page
      }
    };
    return this.logger.log(
      `[Create] data layer object for event "${t}": `,
      i,
      JSON.stringify(i)
    ), i;
  }
  /**
   * Provides the default data layer values.
   *
   * @param user - The current user object, or `null` if not logged in.
   * @returns The default data layer object.
   */
  getDefaultDataLayer(r) {
    return {
      site: {
        domain: "www.webmotors.com.br",
        country: "brasil",
        server: "web",
        tmsVersion: void 0,
        clientType: "pf",
        brandOrigin: "webmotors"
      },
      page: {
        url: void 0,
        trackingCode: {
          idcmp: void 0,
          idcmpint: void 0,
          icid: void 0,
          lkid: void 0
        }
      },
      user: D.transform(
        r,
        this.leadFormData,
        this.storage,
        this.geolocation
      )
    };
  }
};
l = u([
  v(n),
  s(0, a(f)),
  s(1, a(_)),
  s(2, a(E)),
  s(3, a(O))
], l);
export {
  l as AdobeService
};
